import * as React from "react"
import { Redirect } from "react-router-dom"
import {
  route,
  loadingAsyncState,
  any,
  Action,
  async,
  HttpResult,
  unloadedAsyncState,
} from 'widgets-for-react'
import { fromJSX } from '../../../../utils'
import { getCertificateParameter, getParameterByName } from "../../../cms/blocks/utils.gen"
import { CustomRouteParams } from '../../../cms/router/type.gen'
import { PublicSiteState } from '../../../public_site.main.mod'
import { Acf } from "../../../wordpress/types_and_parser/types.ext.gen"
import { WordPress } from '../../../wordpress/wordpress_api'
import { CMUser, CustomPage, CustomPagesState, PublicSiteCustomRoutes } from '../types.mod'
import { CertificateDownloadLayout } from "./certificateDownload.Layout"


declare const html2pdf // This is declared in an external JS file in the layout and wwwroot

export const getSubscriber = async (list_id: string, email: string): Promise<HttpResult<CMUser>> => {
  const response = await fetch(`/api/v1/cm/GetSubscriber/${list_id}?email=${email}`)
  if (!response.ok) return { kind: 'failed', status: response.status }
  const data = await response.json() as CMUser
  return ({ kind: 'result', status: response.status, value: data })

}

const generate_certificate = (
  logos: Acf.ImageArray[],
  top_text: string,
  attendence: string,
  start_date: string,
  end_date: string,
  background_image: Acf.ImageArray,
  congres_name: string,
  speakers_name: string,
  name_of_attendee: string,
  accreditors: WordPress.Accreditors[],
  name: string
) => {
  let html = `<!DOCTYPE html>
<head>
<title></title>
<style>
body {
    margin: 0;
    padding: 0;
    width: 21cm;
    height: 29.7cm;
    overflow: auto;
    height: 100%; }
  
  .certificate {
    width: 28cm;
    height: 35cm;
    overflow: hidden;
    margin-top: -1cm;
    margin: 0;
    padding: 0; }
    .certificate .certificate-main {
      z-index: 10;
      width: -webkit-calc(28cm - 100px);
      width: calc(28cm - 100px);
      margin: 0px 50px;
      top: 9.5cm;
      min-height: 14cm;
      padding: 0.5cm;
      position: absolute; }
    .certificate .certificate-pictures-inner {
      position: absolute;
      top: 1cm;
      right: 0;
      width: 23cm; }
    .certificate .certificate-content {
      background: white;
      border-radius: 10px;
      border-bottom-right-radius: 100px;
      margin: 20px 30px;
      width: 16cm;
      margin-bottom: 1cm;
      padding: 1cm; }
    .certificate .certificate_header {
      display: -webkit-box;
      /* wkhtmltopdf uses this one */
      display: -ms-flexbox;
      display: flex;
      -webkit-box-pack: flex-start;
      /* wkhtmltopdf uses this one */
      -ms-flex-pack: start;
      justify-content: flex-start;
      padding: 0  1cm;
      padding-top: 20px;
      width: 21cm;
      height: 200px; }
    .certificate .certificate_header-logo {
      max-width: 6.5cm; }
      .certificate .certificate_header-logo img {
        width: 100%;
        height: auto; }
    .certificate .certificate_header-text {
      width: 28cm;
      height: 200px;
      background-color: #0095da;
      margin: 0px;
      padding: 1cm 1.2cm;
      font-size: 60px;
      font-family: "Ubuntu", Arial, sans-serif;
      font-style: bold;
      line-height: 1.2;
      color: white; }
    .certificate p, .certificate h1, .certificate h2, .certificate h3, .certificate h4 {
      font-family: "Ubuntu", Arial, sans-serif;
      font-size: 14px;
      line-height: 50%;
      font-weight: 300; }
    .certificate .certificate-background-image {
      width: 28cm;
      height: 16.62cm;
      -o-background-size: cover;
      background-size: cover;
      background-position: center; }
    .certificate .certificate_bottom {
      display: -webkit-box;
      /* wkhtmltopdf uses this one */
      display: -ms-flexbox;
      display: flex;
      -webkit-box-pack: left;
      /* wkhtmltopdf uses this one */
      -ms-flex-pack: left;
      justify-content: left;
      -ms-flex-line-pack: left;
      align-content: left;
      -webkit-box-orient: horizontal;
      -webkit-box-direction: normal;
      -ms-flex-direction: row;
      flex-direction: row;
      width: 100%; }
    .certificate .certificate-text-date {
      width: 100%;
      margin: auto;
      text-align: left;
      color: #fff;
      font-size: 20px; }
    .certificate .certificate-text-blue {
      text-align: left;
      color: #0095da;
      font-weight: bold; }
    .certificate .certificate-extra-spacing {
      line-height: 15pt; }
    .certificate .certificate_signature {
      max-height: 2cm;
      max-width: 100%; }
    .certificate .certificate-text-blue-small {
      text-align: left;
      display: block;
      -webkit-box-orient: vertical;
      -webkit-box-direction: normal;
      -ms-flex-direction: column;
      flex-direction: column;
      color: #0095da;
      width: 33%;
      margin-top: .5cm; }
      .certificate .certificate-text-blue-small p {
        line-height: 15pt;
        margin-left: 5px;
        margin-right: 5px;
        font-size: 13px;
        font-weight: bold; }
      .certificate .certificate-text-blue-small p:first-of-type {
        font-size: 15px;
        margin-left: 0; }
    .certificate .certificate-name-of-attendee {
      text-align: left;
      color: #0095da;
      font-weight: bold;
      line-height: 1;
      font-size: 40px; }
</style>
  
<link href="https://fonts.googleapis.com/css2?family=Ubuntu:wght@300&display=swap" rel="stylesheet">
<link href="https://fonts.googleapis.com/css2?family=Ubuntu" rel="stylesheet">

</head>
<body>

<div class="certificate" style="">
  <div class="certificate-inner">
    <div class="certificate buildingblock listing vertical">      
      <div class="certificate_header">
          ${logos.map(logo => `<img  class="certificate_header-logo" class="certificate_img" src="${logo.url}" >`)}
      </div>
        <div class="certificate_header-text">
          <div style="width: 100%">
            ${top_text}
          </div>
          <p class="certificate-text-date">${attendence} | ${start_date} ${end_date ? `- ${end_date}` : ""}</p>

        </div>
      <div class="certificate-background-image" style="background-image: url(${background_image.url})">

      </div> 

      

      <div class="certificate-main">
       
        <div class="certificate-content">
          
          <p class="certificate-text-blue certificate-extra-spacing">${congres_name}</p>
          <p class="certificate-text-blue certificate-extra-spacing">${speakers_name}</p>
          <p class="certificate-text-grey" style="margin-top: .5cm">${name_of_attendee}</p>
          <h2 class="certificate-name-of-attendee" style="margin-top: .5cm">${name}</h2>
          <div class="certificate_bottom">


          ${accreditors.map(a => `<div class="certificate-text-blue-small" style="">
          <img class="certificate_signature" src="${a.signature.url}">
          <p style="min-height: 40px">${a.name}</p>
          <p>${a.job_title}</p>
        </div>`)}


          </div>
        </div>
      </div> 
    </div>
  </div>
</div>
</body>
</html>`

  let html2canvasOpts = {
    margin: [0, -5, 0, 0], // top, left, bottom, right. To remove the white space on the left.
    html2canvas: {
      scale: 3, // This increases the DPI of the print
      height: 1024 // To remove the second white page from the pdf
    }
  };

  // Check the documentation for more options: https://ekoopmans.github.io/html2pdf.js/
  html2pdf().set(html2canvasOpts).from(html.replace(/localhost:5100/g, 'localhost:5000'), 'string')
    .toPdf()
    .save(`FC-institute-${top_text}`)
}


export const certificateDownloadWidget: CustomPage<CustomPagesState['certificate']> = {
  widget: (p) => {
    return any<Action<CustomPagesState['certificate']>>()([
      async<WordPress.ConferenceResponse>()(p.snd.data).map(a => s => {
        let newData = a(s.data)
        let email = getParameterByName('email')
        if (newData.kind == 'loaded') {
          let f = newData.value
          return ({ ...s, data: newData, cm_user: loadingAsyncState(() => getSubscriber(f.acf.attendees, email)) })
        }
        return ({ ...s, data: newData })
      }),

      async<CMUser>()(p.snd.cm_user).map(a => s => ({ ...s, cm_user: a(s.cm_user) })),

      fromJSX(setState => {
        const { fst, snd } = p
        const { data, cm_user } = snd
        if (data.kind != 'loaded' || cm_user.kind != 'loaded') return <></>
        if (cm_user.value.Code && [1, 203].includes(cm_user.value.Code)) return <Redirect to={'/not-found'} />

        const { title, acf } = data.value
        document.title = title.rendered
        return <CertificateDownloadLayout
          title={title.rendered}
          start_date={acf.start_date}
          onDownload={() => generate_certificate(
            acf.logos.map(l => l.logo),
            acf.certificate_top_text,
            acf.attendence_certificate,
            acf.start_date,
            acf.end_date,
            acf.background_image,
            acf.congress_name,
            acf.speakers_name,
            acf.name_of_attendee,
            acf.accreditors,
            cm_user.value.Name
          )}
        />
      })
    ])
  },
  route: route<{ slug: string, type: WordPress.PostType }, CustomRouteParams<PublicSiteState, PublicSiteCustomRoutes>>(
    '/:lang?/download-certificate/:slug*',
    s => ({ kind: 'certificate', slug: s.slug, type: getCertificateParameter('type') as WordPress.PostType })
  ),
  // http://localhost:5000/download-certificate/webinar?type=webinars&email=cerowlands@cardiffmet.ac.uk
  getState: (s: PublicSiteState) => ({ ...s.certificate, }),
  setState: (s: PublicSiteState, ss: CustomPagesState['certificate']) => ({
    ...s,
    certificate: ss,
  }),
  updateStateBasesOnRoute: (s, r) => {
    if (r.kind != 'certificate') return s
    return ({
      ...s,
      certificate: {
        ...s.certificate,
        cm_user: unloadedAsyncState(),
        data: loadingAsyncState(() => WordPress.api<WordPress.ConferenceResponse>().select(r.type)
          .where({ slug: r.slug })
          .getOne()
          .then(data => {
            if (data.status != 200) return ({ kind: 'failed', status: data.status })
            return ({ kind: 'result', status: data.status, value: data.data })
          })
        )
      }
    })
  }
}
